/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { EApplicationStatus, EApplicationType, type TEntityInfo, type TEntitySection, type TAuthUserPermission } from '@/interfaces'

import { AuthState } from '../auth'

import { FormState } from '.'

export const defaultEntityPermissions: TAuthUserPermission = {
  create: false,
  delete: false,
  edit: false,
  read: false,
  stream: false,
}

/**
 * Set form permissions based on user permissions
 */
export function setPermisionsToForm(): void {
  // Obtener el status global de la postulación actual
  const currentApplicationStatus = FormState.currentFormValues.peek()?.applicationstatus;
  const formSetted = FormState.currentForm.peek().map((item) => {
    // Asignar permisos por usuario
    item.permission =
      AuthState.userPermissions.peek()[item.name!] ?? defaultEntityPermissions

    // Deshabilitar edición si la postulación está en estado DISABLED y la pestaña corresponde
    if (currentApplicationStatus === EApplicationStatus.DISABLED) {
      // Solo deshabilitar las tabs CNucleoFamiliar y CObservacion
      if (["CNucleoFamiliar", "CObservacion"].includes(item.name!)) {
        item.permission = {
          ...item.permission,
          create: false,
          delete: false,
          edit: false
        }
      }
    }
    return item
  })

  // Actualizar el estado global del formulario con los permisos ajustados
  FormState.currentForm.value = [...formSetted]
}

function getFieldRenderInfo(
  fieldFormAccess: string[],
  appType: EApplicationType
) {
  if (fieldFormAccess.length < 2) {
    return {
      render: true,
      required: false,
    }
  }

  const renderImprovement =
    appType === EApplicationType.IMPROVEMENT &&
    fieldFormAccess.some((item) => item.includes('MV'))
  const renderRural =
    appType === EApplicationType.RURAL_LIVING &&
    fieldFormAccess.some((item) => item.includes('VR'))
  const renderUrban =
    appType === EApplicationType.URBAN_LIVING &&
    fieldFormAccess.some((item) => item.includes('VU'))

  const isRequired =
    (renderImprovement && fieldFormAccess.includes('MV*')) ||
    (renderUrban && fieldFormAccess.includes('VU*')) ||
    (renderRural && fieldFormAccess.includes('VR*'))

  return {
    render: renderImprovement || renderRural || renderUrban,
    required: isRequired,
  }
}

function getFieldFormsAccess(fieldLabel?: string): string[] {
  if (!fieldLabel) {
    return []
  }

  return fieldLabel
    .split('##')
    .map((labelItem) => labelItem.trim())
    .filter((item) => item.length > 0)
}

function setSectionFormFields(
  entitySection: TEntitySection,
  applicationType: EApplicationType
) {
  const fields = (entitySection?.fields ?? [])
    .map((sectionField) => {
      const fieldFormAccessInfo = getFieldFormsAccess(sectionField.label)
      const fieldRenderInfo = getFieldRenderInfo(
        fieldFormAccessInfo,
        applicationType
      )

      sectionField.label = fieldFormAccessInfo[0]
      sectionField.render = fieldRenderInfo.render
      sectionField.required = fieldRenderInfo.required || sectionField.required

      return { ...sectionField }
    })
    .filter((item) => item.render)

  entitySection.fields = fields

  return { ...entitySection }
}

function setEntitySections(
  entity: TEntityInfo,
  applicationType: EApplicationType
) {
  const entityFormAccessInfo = getFieldFormsAccess(entity.label)
  const entityRenderInfo = getFieldRenderInfo(
    entityFormAccessInfo,
    applicationType
  )

  const entitySections = (entity.sections ?? [])
    .map((entitySection) =>
      setSectionFormFields(entitySection, applicationType)
    )
    .filter((item) => (item.fields?.length ?? 0) > 0)

  entity.sections = entitySections
  entity.label = entityFormAccessInfo[0]
  entity.render = entityRenderInfo.render

  return { ...entity }
}

export function setCurrentFormFields(applicationType: EApplicationType) {
  const currentForm = FormState.currentForm.peek()

  currentForm
    .map((entity) => setEntitySections(entity, applicationType))
    .filter((item) => item.render)

  FormState.currentForm.value = [...currentForm]
}
